import { useLegacyEffect } from "helper/customHook";
import { memo, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import List from "@mui/material/List";

import {
  changeIsHiddenSidenav,
  changeIsMiniSidenav,
  changeIsMiniWindow,
} from "theme/redux";
import { themesSelector } from "theme/selector";

import LogoMBS from "./LogoMBS";
import NavGroup from "./NavGroup";
import AccountInfo from "./AccountInfo";

import { logOutNavItem, sidenavData, filterNavByScreenKeys } from "./const";

import { roleMenuDataSelector } from "./redux/selector";
import { getRolesMenuStart } from "./redux/roleMenu";

import { DrawerSidenav, InfoWrapper, Menu, Version } from "./styles";
import { isOpenDialogSelector } from "redux-store/static/redux/selector";
import { DIALOG } from "helper/enum/dialogEnum";

function Sidenav() {
  const dispatch = useDispatch();
  const sidenavRef = useRef(null);
  const open = useSelector(isOpenDialogSelector(DIALOG.CHANGE_AVATAR));

  useLegacyEffect(() => {
    dispatch(getRolesMenuStart());
  }, []);

  const { isMiniSidenav, isHiddenSidenav, isMiniWindow } =
    useSelector(themesSelector);
  const role = useSelector(roleMenuDataSelector);

  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      if (window.innerWidth < 1200) {
        dispatch(changeIsHiddenSidenav(true));
        dispatch(changeIsMiniWindow(true));
        dispatch(changeIsMiniSidenav(false));
      } else {
        dispatch(changeIsHiddenSidenav(false));
        dispatch(changeIsMiniWindow(false));
      }
    }

    window.addEventListener("resize", handleMiniSidenav);
    handleMiniSidenav();
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (sidenavRef.current && !sidenavRef.current.contains(event.target)) {
        // kiếm tra xem có đang ở màn hình nhỏ và trừ trường hợp đang ở dialog thay đổi avatar
        if (isMiniWindow && !open) {
          // chờ sau khi xử lý các action khác như thông báo, thay đổi avatar để tránh đóng luôn
          setTimeout(() => {
            dispatch(changeIsHiddenSidenav(true));
          }, 200);
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMiniWindow, open, sidenavRef, dispatch]);

  const sideNavDataWithRole = filterNavByScreenKeys(sidenavData, role);

  const renderListSideNavLvOne = sideNavDataWithRole.map((item) => {
    return (
      <NavGroup
        key={item.value}
        navGroupData={item}
        isMiniSidenav={isMiniSidenav}
        position="top"
      />
    );
  });

  return isHiddenSidenav ? (
    <></>
  ) : (
    <DrawerSidenav
      ref={sidenavRef}
      variant="permanent"
      ownerState={{ isMiniSidenav }}
    >
      <InfoWrapper isMiniSidenav={isMiniSidenav}>
        <LogoMBS />
        <AccountInfo />
      </InfoWrapper>
      <Menu>
        <List>{renderListSideNavLvOne}</List>
        <NavGroup
          key={logOutNavItem.value}
          navGroupData={logOutNavItem}
          isMiniSidenav={isMiniSidenav}
          position="bottom"
        />
      </Menu>
      {process.env.REACT_APP_VERSION && (
        <Version>{process.env.REACT_APP_VERSION}</Version>
      )}
    </DrawerSidenav>
  );
}

export default memo(Sidenav);
